import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import ConsultingPage from "@/pages/ConsultingPage";
import { initAnalytics } from "@/lib/analytics";

initAnalytics();

// Decide which experience to render.
// - Production: the `consulting.` subdomain always shows the consulting page.
// - Local/preview: append `?consulting` or visit `/consulting` to preview it.
function resolveExperience() {
  if (typeof window === "undefined") return <App />;

  // Deterministic flag injected into the consulting build's index.html.
  if (window.__SITE__ === "consulting") return <ConsultingPage />;

  const host = window.location.hostname || "";
  const path = window.location.pathname || "";
  const search = window.location.search || "";

  const isConsultingHost = host.startsWith("consulting.");
  const isConsultingPath = path.replace(/\/+$/, "") === "/consulting";
  const isConsultingQuery = /(^|[?&])consulting(=|&|$)/.test(search);

  if (isConsultingHost || isConsultingPath || isConsultingQuery) {
    return <ConsultingPage />;
  }
  return <App />;
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<React.StrictMode>{resolveExperience()}</React.StrictMode>);
